'use client';
import React from 'react';
import Image from 'next/image';
import style from './style.module.scss';
import Marquee from 'react-fast-marquee';
import Link from 'next/link';

interface PreviewPicture {
  url: string;
  data: any;
  altText?: string; // Допустим, текст для альтернативного описания
  formats: any;
}

interface UserfulLinksItem {
  id: number;
  title: string;
  link: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  previewPicture?: PreviewPicture; // Добавляем поле previewPicture
}

interface MarqueeItemsProps {
  data: UserfulLinksItem[]; // data — это массив объектов UserfulLinksItem
}

export const MarqueeItems = ({ data }: MarqueeItemsProps) => {
  return (
    <Marquee className={style.marquee} pauseOnHover autoFill direction="right" speed={50}>
      {data.map((elem: UserfulLinksItem, index: number) => (
        <Link href={elem?.link || '/'} target="_blank" className={style.item} key={index}>
          <Image
            src={
              process.env.NEXT_PUBLIC_APP_UPLOAD_URL +
              (elem?.previewPicture?.formats?.large?.url || elem?.previewPicture?.url)
            }
            width={120}
            height={100}
            alt="skill"
          />
        </Link>
      ))}
    </Marquee>
  );
};
